import * as angular from 'angular';
import { MembersPanelComponent } from './members-panel/members-panel.component';
import { MembersRoutesConfig } from './members.routes';
import { MembersListComponent } from './members-list/members-list.component';
import { MembersBrowserComponent } from './members-browser';
import { MemberSearchService } from './member-search-service';

/* prettier-ignore */
export const WorkspaceSettingsFeatureMembersAngularJsModule = angular
  .module('workspace-settings-feature-members', [])
  .config(MembersRoutesConfig)
  .component('membersPanel', MembersPanelComponent)
  .component('membersList', MembersListComponent)
  .component('membersBrowser', MembersBrowserComponent)
  .service('MemberSearchService', MemberSearchService)
  .name;
